export default "__VITE_ASSET__6jJ3e97R__"